module.exports = {
      id: "vikatan-usage",
      viewBox: "0 0 30 30",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#vikatan",
      toString: function () {
        return this.url;
      }
    }